export default __webpack_public_path__ + "static/media/cli-alphaville-mall.f0a24a90.jpg";